import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EmployerComponent } from './employer.component';
import { EmployerProfileComponent } from './employer-profile/employer-profile.component';
import { CandidateListComponent } from './candidate-list/candidate-list.component';
import { CandidateDetailComponent } from './candidate-detail/candidate-detail.component';
import { AssignedCandidatesListComponent } from './assigned-candidates-list/assigned-candidates-list.component';
import { AssignedCandidateDetailComponent } from './assigned-candidate-detail/assigned-candidate-detail.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

const routes: Routes = [{ path: '', component: EmployerComponent , children:[
  {path : 'employer-profile' , component:EmployerProfileComponent},
  {path:  'candidate-list' , component:CandidateListComponent},
  {path:  'candidate-details/:id' , component:CandidateDetailComponent},
  {path:  'assigned-candidates-list', component:AssignedCandidatesListComponent},
  {path:  'assigned-candidate-detail/:id' , component:AssignedCandidateDetailComponent},
  {path: 'reset-password' , component:ResetPasswordComponent}
  
] }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmployerRoutingModule { }
